import React, {useEffect} from 'react';
import {
    useAddresses,
    useEmails,
    useGetAddresses,
    useGetEmails, useGetPhones,
    useGetSocials,
    usePhones,
    useSocials
} from "./stores/contactStore";
import {FaInstagram, FaFacebook, FaTwitter, FaYoutube, FaTelegram, FaWhatsapp} from "react-icons/fa";

const socialIcons = {
    instagram: FaInstagram,
    facebook: FaFacebook,
    twitter: FaTwitter,
    youtube: FaYoutube,
    telegram: FaTelegram,
    whatsapp: FaWhatsapp,
};
const Footer = () => {
    const addresses = useAddresses()
    const getAddresses = useGetAddresses()
    const emails = useEmails()
    const getEmails = useGetEmails()
    const socials = useSocials()
    const getSocials = useGetSocials()
    const phones = usePhones()
    const getPhones = useGetPhones()

    useEffect(() => {
        void getAddresses();
        void getEmails();
        void getSocials();
        void getPhones();
    }, [getAddresses, getEmails, getPhones, getSocials]);

    return (
        <footer className={'flex flex-col place-self-end w-full'}>
            <div className="bg-[#2C2C2C] py-5 d-flex flex-column justify-content-between">
                <div className="container">
                    <div className="flex md:flex-row flex-col md:items-center px-10 space-y-5 md:space-y-0 justify-between line-clamp-1">
                        <div className="col-md-4">
                            <h4 className="mb-3 text-[#EEEEEE] font-medium">Свяжитесь с нами</h4>
                            <ul className="text-[#AAAAAA] ">
                                {phones.map((phone) => (
                                    <li className={'hover:text-[#EEEEEE]'} key={phone.id}>{phone.phone_number}</li>
                                ))}
                                {emails.map((email) => (
                                    <li className={'hover:text-[#EEEEEE]'} key={email.id}>{email.email}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <h4 className="mb-3 text-[#EEEEEE] font-medium">Наши меседжеры</h4>
                            <ul className="text-[#AAAAAA]">
                                {socials.map((social) => {
                                    const Icon = socialIcons[social.name.toLowerCase()];
                                    return (
                                    <li className={'hover:text-[#EEEEEE]'} key={social.id}><a className={'flex gap-1'} href={social.url}>{Icon ?
                                        <Icon className="w-5 h-5"/> : null}{social.name}</a></li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <h4 className="mb-3 text-[#EEEEEE] font-medium">Наши адреса</h4>
                            <ul className="text-[#AAAAAA]">
                                {addresses.map((address) => (
                                    <li className={'hover:text-[#EEEEEE]'} key={address.id}><a href={address.url}>{address.address}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'bg-black'}>
                <h3 className={'text-white py-4 text-center'}>© 2023 Все авторские права защищены.</h3>
            </div>
        </footer>
    );
};

export default Footer;